import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Sadece route değişimlerinde scroll'u sıfırla
    // Mobilde daha yumuşak geçiş için timeout ekle
    const timeoutId = setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: window.innerWidth > 768 ? "smooth" : "auto",
      });
    }, 10);

    return () => clearTimeout(timeoutId);
  }, [pathname]);

  return null;
}

export default ScrollToTop;